import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useSettings } from "../contexts/SettingsContext";

/**
 * Shared logic for Dashboard functionality
 * Contains ONLY code that applies to both mobile and desktop platforms
 * - Auth state management
 * - User profile data
 * - Sign out functionality
 * - Age calculation
 */
export function useDashboardLogic() {
  const { user, userProfile, signOut, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/signin", { replace: true });
  };

  // Get user's age from settings context
  const { settings } = useSettings();
  const age = settings?.profile.currentAge ?? null;

  return {
    user,
    userProfile,
    loading,
    error,
    age,
    handleSignOut,
    navigate,
  };
}
